import './Footer.css';
import PropTypes from 'prop-types';
import React from 'react';
import { pure } from 'recompose';
import {Link} from "react-router-dom";
import ModalExample from "./popup";
import {getStore} from '../../../index';

const Footer = ({ subtitle, steps, locale }) =>

    // console.log(getStore().getState());
    // console.log(getStore().getState().shift.auth.authenticated);

     (
    <div className="footer">
      <div className="text" style={{ color: '#1f5c71' }}>
        {/*{{locale}}*/}
        <Link to="/">
            Home
        </Link>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Link to={`/${locale}/termofuse`}>
          Terms of Use
        </Link>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Link to={`/${locale}/help`}>
          Help
        </Link>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <ModalExample hasTitle
                      info
                      className="modal_lg"
                      store = {getStore()}
        >
        </ModalExample>
      </div>

      <div className="copyrighttext">
        Copyright © 2020 Next Pathway Inc. All rights reserved.
        <br />
        FUSE™ is an existing, applied for or registered trademark of Next Pathway
        Inc.
      </div>
    </div>)


Footer.propTypes = {
  subtitle: PropTypes.string,
  steps: PropTypes.array,
  selectedStep: PropTypes.number,
  icon: PropTypes.string,
  locale: PropTypes.string
};

Footer.defaultProps = {
  selectedStep: 0,
  icon: 'default',
  locale: 'en-CA'
};

export default pure(Footer);



// WEBPACK FOOTER //
// ./src/components/views/Footer/index.js